/** Class representing a strategy to compare a path with a static string */
export class DefaultPathAssertionStrategy {
  pathClass;
  /** Create a new DefaultPathAssertionStrategy */
  constructor() {
    this.pathClass = String;
  }

  /** Checks if the current strategy applies for the type of path representation pass as parameter
   * @param {Object} path - Object that represents a path in the application
   * @returns {Boolean} - Returns if the current strategy applies for the type of path
   */
  appliesForPath(path) {
    return path instanceof this.pathClass;
  }

  /** Checks if the object representing the app path matches with the current path
   * @param {Object} - Object that represents a path in the application
   * @returns {Boolean} - Returns if the current strategy applies for the type of path
   */
  testPath(pathToAssert, currentPath) {
    return pathToAssert === currentPath;
  }
}

/** Class representing a strategy to compare check if a path matches using a RegExp */
export class RegexpPathAssertionStrategy extends DefaultPathAssertionStrategy {
  /** Create a new RegexpPathAssertionStrategy */
  constructor() {
    super();
    this.pathClass = RegExp;
  }

  /** Checks if the object representing the app path matches with the current path using a RegExp
   * @param {Object} - Object that represents a path in the application
   * @returns {Boolean} - Returns if the current strategy applies for the type of path
   */
  testPath(pathToAssert, currentPath) {
    return pathToAssert.test(currentPath);
  }
}
